import { InferGetServerSidePropsType } from 'next'
import { serveExpressCheckoutProxyProps } from '@modules/booking/data/server'
import { VenuePageProvider } from '@modules/venue/controllers/venue-page-provider'

import { ssrProps } from '@utils/server'
import { BookingProxy } from '@modules/booking/controllers/booking-proxy'
import { InventoryMeta } from '@modules/inventory/views/inventory-meta'
import { NoIndexHeader } from '@components/no-index-header'

export default function ExpressCheckoutProxyPage(
  props: InferGetServerSidePropsType<typeof getServerSideProps>
) {
  const { venue, inventory, integrations } = props

  return (
    <>
      <InventoryMeta venue={venue} inventory={inventory} />
      <NoIndexHeader />
      <VenuePageProvider venue={venue} integrations={integrations}>
        <BookingProxy inventory={inventory} />
      </VenuePageProvider>
    </>
  )
}

export const getServerSideProps = ssrProps(serveExpressCheckoutProxyProps)
